var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMovementSusda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1052,
    height: 1051,
    viewBox: "0 0 1052 1051",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 525.639,
    cy: 525.5,
    r: 525.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M455.079 354.629H523.597L368.395 696.625H299.877L455.079 354.629Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M592.151 354.629H523.633L678.836 696.625H747.354L592.151 354.629Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M523.038 523.542L591.437 697.217H454.638L523.038 523.542Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M900.245 578.282C873.82 761.093 716.494 901.547 526.363 901.547C336.231 901.547 178.905 761.093 152.48 578.282H93.5606C120.391 793.443 303.933 959.936 526.363 959.936C748.792 959.936 932.334 793.443 959.165 578.282H900.245Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152.48 469.238C178.905 286.426 336.231 145.972 526.363 145.972C716.494 145.972 873.82 286.426 900.245 469.238H959.165C932.334 254.076 748.792 87.583 526.363 87.583C303.933 87.583 120.391 254.076 93.5605 469.238H152.48Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovementSusda);
export default __webpack_public_path__ + "static/media/movement-susda.297ba996dcaa8bb515fdf9f10c21c3a3.svg";
export { ForwardRef as ReactComponent };